// extracted by mini-css-extract-plugin
module.exports = {"badge":"PreviewBadge_badge__jr8Wt"};